// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gr-0";